import { TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import { TaskField } from '@atom/types/task';
import { WorkOrderField } from '@atom/types/work';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './workOrdersFilters.module.css';

type WorkOrdersFiltersNumericRangeProps = {
  field: WorkOrderField | TaskField;
  startValue: any;
  endValue: any;
  onStartChange: (id: string, value: any) => void;
  onEndChange: (id: string, value: any) => void;
  disabled?: boolean;
  dataCy?: string;
};

const WorkOrdersFiltersNumericRange = ({
  field,
  startValue,
  endValue,
  onStartChange,
  onEndChange,
  disabled,
  dataCy,
}: WorkOrdersFiltersNumericRangeProps) => {
  return (
    <div className={classes.filtersNumberRange}>
      <TextField
        value={startValue}
        onChange={event =>
          onStartChange(
            field.id,
            !isNilOrEmpty(event.target.value) ? event.target.value : '',
          )
        }
        label={field.title}
        type="number"
        variant="standard"
        inputLabelColor={colors.neutral.dim}
        disabled={disabled}
        data-cy={dataCy && `${dataCy}Start`}
      />
      <span>to</span>
      <TextField
        value={endValue}
        onChange={event =>
          onEndChange(
            field.id,
            !isNilOrEmpty(event.target.value) ? event.target.value : '',
          )
        }
        label=""
        type="number"
        variant="standard"
        disabled={disabled}
        data-cy={dataCy && `${dataCy}End`}
      />
    </div>
  );
};

export default WorkOrdersFiltersNumericRange;
